// extracted by mini-css-extract-plugin
export default {"buttons":"Actions_buttons__dEeLM"};